<template>
    <div v-loading="mixinLoading||pageLoading">
        <div class="page-wrap">
            <div class="filter-bar">
                <el-form :inline="true" :model="formItem" class="">
                    <el-form-item label="选择广告" class="mb10">
                        <el-select v-model="formItem.ad1" placeholder="选择广告：" filterable clearable>
                            <el-option
                                v-for="item in adList"
                                :key="item.ad_id"
                                :label="item.ad_name"
                                :disabled="item.ad_id==formItem.ad2||item.ad_id==formItem.ad3"
                                :value="item.ad_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" class="mb10">
                        <el-select v-model="formItem.ad2" placeholder="选择广告：" filterable clearable>
                            <el-option
                                v-for="item in adList"
                                :key="item.ad_id"
                                :label="item.ad_name"
                                :disabled="item.ad_id==formItem.ad1||item.ad_id==formItem.ad3"
                                :value="item.ad_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" class="mb10">
                        <el-select v-model="formItem.ad3" placeholder="选择广告：" filterable clearable>
                            <el-option
                                v-for="item in adList"
                                :key="item.ad_id"
                                :label="item.ad_name"
                                :disabled="item.ad_id==formItem.ad1||item.ad_id==formItem.ad2"
                                :value="item.ad_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="mb10 ml10">
                        <el-button type="primary" @click="onSubmit" :loading="pageLoading">对比</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="info-list" v-if="compareData.length>0">
                <el-row :gutter="20">
                    <el-col v-for="item in compareData" :key="item.ad_name" :span="8">
                        <div class="list-item">
                            <h3 class="title-group">基本信息</h3>
                            <div class="text-info">
                                <el-descriptions title="" :column="1">
                                    <el-descriptions-item label="广告"><span style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: inline-block;max-width: 230px;" :title="item.ad_name">{{item.ad_name}}</span></el-descriptions-item>
                                    <el-descriptions-item label="APP">58同城</el-descriptions-item>
                                    <el-descriptions-item label="每日预算">{{item.daily_budget}}</el-descriptions-item>
                                    <el-descriptions-item label="投放日期">{{item.start_date}}</el-descriptions-item>
                                    <el-descriptions-item label="投放地区">{{item.region}}</el-descriptions-item>
                                    <el-descriptions-item label="受众">{{item.audience}}</el-descriptions-item>
                                    <el-descriptions-item label="出价">{{item.price}}</el-descriptions-item>
                                </el-descriptions>
                            </div>
                            <h3 class="title-group">数据表现</h3>
                            <div class="text-info">
                                <el-descriptions title="" :column="1">
                                    <el-descriptions-item label="支出">{{(+item.local_spend).toFixed(2)}}</el-descriptions-item>
                                    <el-descriptions-item label="展示次数">{{item.impressions}}</el-descriptions-item>
                                    <el-descriptions-item label="ECPM">{{item.ecpm}}</el-descriptions-item>
                                    <el-descriptions-item label="点击次数">{{item.taps}}</el-descriptions-item>
                                    <el-descriptions-item label="点击率">{{item.imp_click_rate}}%</el-descriptions-item>
                                    <el-descriptions-item label="点击成本">{{item.cli_price}}</el-descriptions-item>
                                    <el-descriptions-item label="安装次数">{{item.installs}}</el-descriptions-item>
                                    <el-descriptions-item label="转化率">{{item.cli_installs_rate}}%</el-descriptions-item>
                                    <el-descriptions-item label="转化成本">{{item.installs_price}}</el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </div>
                    </el-col>
                </el-row>

            </div>
            <div class="chart-list">
                <div v-if="compareData.length<=0" class="mt60 mb60 tac text-color-gray">暂无数据</div>
                <div class="chart-bar ml10">
                    <el-select v-model="chartType" placeholder="请选择" @change="changeChartType" v-if="compareData.length>0">
                        <el-option
                            v-for="item in chartTypeOptions"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="test-chart full-w" id="testChart" style="height: 400px;"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import { cloneDeep } from 'lodash';
    import * as echarts from 'echarts';
    import testData from './testData';
    import dayjs from 'dayjs';
    let isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
    let isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
    dayjs.extend(isSameOrBefore);
    dayjs.extend(isSameOrAfter);

    export default {
        name: "AdTest",
        props:{
            zone:String,
            rangeTime:Array,
            mixinLoading:Boolean,
        },
        components: {
        },
        data() {
            return {
                pageName:'apple_promotion_manage_ad_test',
                formItem:{
                    ad1:'',
                    ad2:'',
                    ad3:'',
                },
                testChart:null,
                chartData:{},
                chartType:'local_spend_data',
                chartTypeOptions:[
                    {
                        name:'支出',
                        value:'local_spend_data',
                    },
                    {
                        name:'展示次数',
                        value:'impressions_data',
                    },
                    {
                        name:'ECPM',
                        value:'ecpm_data',
                    },
                    {
                        name:'点击次数',
                        value:'taps_data',
                    },
                    {
                        name:'点击率',
                        value:'imp_click_rate_data',
                    },
                    {
                        name:'点击成本',
                        value:'cli_price_data',
                    },
                    {
                        name:'安装次数',
                        value:'installs_data',
                    },
                    {
                        name:'转化率',
                        value:'cli_installs_rate_data',
                    },
                    {
                        name:'转化成本',
                        value:'installs_price_data',
                    },
                ],
                adList:[
                    {
                        "ad_id": 1692430602,
                        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
                        "daily_budget": 45000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1692401862,
                        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
                        "daily_budget": 45000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1516269753,
                        "ad_name": "品牌词-长尾-58品牌词组",
                        "daily_budget": 75000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1516269491,
                        "ad_name": "品牌词-核心-58品牌词组",
                        "daily_budget": 75000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1692430564,
                        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
                        "daily_budget": 4000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1692431402,
                        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
                        "daily_budget": 4000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1115,
                        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
                        "daily_budget": 45000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1114,
                        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
                        "daily_budget": 45000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1113,
                        "ad_name": "58同城-品牌词-长尾-Default Ad",
                        "daily_budget": 75000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1112,
                        "ad_name": "58同城-品牌词-核心-Default Ad",
                        "daily_budget": 75000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1111,
                        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
                        "daily_budget": 4000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    },
                    {
                        "ad_id": 1110,
                        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
                        "daily_budget": 4000,
                        "start_date": "2024/1/31-不限",
                        "region": "中国大陆",
                        "audience": "不限",
                        "price": 1
                    }
                ],
                compareData:[],
                pageLoading:false,
            }
        },
        computed:{
            ...mapGetters(['tabs_map', 'apple_reload','apple_list_page_query']),

        },
        watch: {
            rangeTime(){
                this.onSubmit();
            },
        },
        mounted(){
            console.log('testData',testData);
            window.addEventListener("resize", this.resizeChart);
            this.initChart();
        },
        methods:{
            async onSubmit(){
                console.log('onSubmit');
                this.pageLoading = true;
                await this.waitTime(500);
                this.pageLoading = false;
                let selectList = [this.formItem.ad1,this.formItem.ad2,this.formItem.ad3].filter(item=>!!item);
                if(selectList.length<=0) return this.$message.error('请选择需要对比的广告');
                this.compareData = selectList.map(item=>{
                    let adData = cloneDeep(this.adList.find(inner=>inner.ad_id==item));
                    let actionAdData = testData.filter(item=>item.ad_name==adData.ad_name).filter(item=>{
                        return dayjs(item.date).isSameOrAfter(this.rangeTime[0], 'day')&&dayjs(item.date).isSameOrBefore(this.rangeTime[1], 'day');
                    });


                    adData.date_data =  actionAdData.map(item=>item.date).reverse();

                    adData.local_spend_data = actionAdData.map(item=>item.local_spend).reverse();
                    adData.impressions_data = actionAdData.map(item=>item.impressions).reverse();
                    adData.ecpm_data = actionAdData.map(item=>item.ecpm).reverse();
                    adData.taps_data = actionAdData.map(item=>item.taps).reverse();
                    adData.imp_click_rate_data = actionAdData.map(item=>parseFloat(item.imp_click_rate)).reverse();
                    adData.cli_price_data = actionAdData.map(item=>item.cli_price).reverse();
                    adData.installs_data = actionAdData.map(item=>item.installs).reverse();
                    adData.cli_installs_rate_data = actionAdData.map(item=>parseFloat(item.cli_installs_rate)).reverse();
                    adData.installs_price_data = actionAdData.map(item=>item.installs_price).reverse();


                    //local_spend impressions ecpm taps imp_click_rate cli_price installs cli_installs_rate installs_price
                    // 支出（local_spend）	展示次数（impressions）	ECPM（ecpm）	点击次数（taps）	点击率（imp_click_rate）	点击成本（cli_price）	安装次数（installs）	转化率（cli_installs_rate）	转化成本（installs_price）

                    // 求和：支出、展示次数、点击次数、安装次数
                    // 平均值：ECPM、点击率、点击成本、转化率、转化成本
                    adData.local_spend = this.getTotalVal(adData.local_spend_data);
                    adData.impressions = this.getTotalVal(adData.impressions_data);
                    adData.ecpm = this.getAvgVal(adData.ecpm_data);
                    adData.taps = this.getTotalVal( adData.taps_data);
                    adData.imp_click_rate = this.getAvgVal(adData.imp_click_rate_data);
                    adData.cli_price = this.getAvgVal(adData.cli_price_data);
                    adData.installs = this.getTotalVal(adData.installs_data);
                    adData.cli_installs_rate = this.getAvgVal(adData.cli_installs_rate_data);
                    adData.installs_price = this.getAvgVal(adData.installs_price_data);

                    return {...adData};
                });
                this.updateChart();
            },
            async waitTime(val){
                await new Promise(resolve=>{
                    setTimeout(()=>{
                        resolve();
                    },val||500)
                })
            },
            getAvgVal(list){
                if(list.length<=0) return 0;
                let isRate = list.some(item=>(item+'').includes('%'));
                let list2 = list.map(item=>(item+'').replace('%',''));
                let val = list2.reduce((a,b)=>+a + +b)/list.length;
                val = val.toFixed(2);
                return isRate?val+'%':val;
            },
            getTotalVal(list){
                if(list.length<=0) return 0;
                return list.reduce((a,b)=>a+b);
            },
            initChart(){
                let $chart = document.getElementById('testChart');

                if(!$chart) return;
                if(!this.testChart){
                    this.testChart = echarts.init($chart);
                }

                if(this.compareData.length<=0) return;

                let option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: this.compareData.map(item=>item.ad_name),
                    },
                    grid: {
                        left: '20px',
                        right: '4%',
                        bottom: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: this.compareData[0]?.date_data||[],
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series:this.compareData.map(item=>{
                        return  {
                            name: item.ad_name,
                            type: 'line',
                            // stack: 'Total',
                            data: item[this.chartType],
                        }
                    }),
                };

                this.testChart.setOption(option,true);

                this.resizeChart();
            },
            updateChart(){
                let option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: this.compareData.map(item=>item.ad_name),
                    },
                    grid: {
                        left: '20px',
                        right: '4%',
                        bottom: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: this.compareData[0]?.date_data||[],
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series:this.compareData.map(item=>{
                        return  {
                            name: item.ad_name,
                            type: 'line',
                            // stack: 'Total',
                            data: item[this.chartType],
                        }
                    }),
                };

                this.testChart.setOption(option,true);

                this.resizeChart();
            },
            changeChartType(){
                this.updateChart();
            },
            resizeChart(){
                if(this.testChart){
                    this.testChart.resize();
                }
            },
            getSearchList(){},
        },
        beforeDestroy(){
            // 组件销毁之前必须先销毁ECharts实例,否则charts里的tooltip将阴魂不散
            if(this.testChart){
                this.testChart.dispose();
            }
            window.removeEventListener("resize", this.resizeChart);
        },
    }
</script>

<style lang="scss" scoped>
    .mb10{
        margin-bottom: 10px;
    }
    .page-wrap{
        min-height: calc(100vh - 110px);

        .filter-bar{
            background-color: #fff;
            padding: 10px 20px 0;
        }

        .info-list{
            margin-top: 10px;
            /*background-color: #fff;*/

            .list-item{
                background-color: #fff;
                padding: 0 10px;

                ::v-deep .el-descriptions-item__label{
                    width: 160px;
                    text-indent: 10px;
                }

                ::v-deep .el-descriptions-item__content{
                    /*font-size: 14px;*/
                    color: #303133;
                }

            }
        }

        .chart-list{
            margin-top: 10px;
            background-color: #fff;
            padding: 10px;
            min-height: 200px;
        }

        .title-group {
            border-bottom: solid 1px #DCDFE6;
            line-height: 38px;
            height: 38px;
            margin-bottom: 10px;
        }
    }
</style>


